class SupportBlock {

    constructor(el) {
        this.el = el

        this.autoRenewControl = this.el.querySelector('input[name="membership-auto-renew"]')
        this.autoRenewInputs = this.el.querySelectorAll('[data-set-auto-renew]')

        this.autoRenewControl.addEventListener('change', this.toggleAutoRenew.bind(this))

        this.toggleAutoRenew()
    }

    toggleAutoRenew() {
        console.log('toggling auto renew');

        let checked = this.autoRenewControl.checked

        this.autoRenewInputs.forEach((el) => {
            el.checked = checked
        })
    }
}

document.addEventListener('DOMContentLoaded', function() {
    let support_blocks = document.querySelectorAll('.support-block--membership')

    support_blocks.forEach((el) => {
        new SupportBlock(el)
    })
})
